/* eslint-disable @typescript-eslint/no-explicit-any */
import {VersionVariants} from '@jobseeker/lotus/enums';
import dynamic from 'next/dynamic';
import {Footer, Header} from './V2/index';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = dynamic(
  () => import('@jobseeker/lotus/elements/NotImplemented')
);
componentMap[VersionVariants.VERSION_TWO] = dynamic(() => import('./V2'));

const ApplyJobDialog = (props: any) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};
export {Footer, Header};
export default ApplyJobDialog;
